import classNames from 'classnames'
import React from 'react'

import { Theme, Typography } from '@mui/material'
import { createStyles, withStyles, WithStyles } from '@mui/styles'

const Footer: React.SFC<FooterProps & WithStyles<typeof styles>> = ({ classes, whiteFont }) => {
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  })
  const currentYear = new Date().getFullYear()
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <Typography color="inherit">© {currentYear} FounderNest</Typography>
        <Typography color="inherit" className={classes.separator}>
          •
        </Typography>
        <Typography>
          <a className={classes.contactUs} href="mailto:hello@foundernest.com">
            Contact us
          </a>
        </Typography>
      </div>
    </footer>
  )
}

type FooterProps = {
  whiteFont: boolean
}

const styles = ({ spacing, palette, transitions }: Theme) =>
  createStyles({
    footer: {
      padding: '2rem 0',
      textAlign: 'center',
      display: 'flex',
      position: 'absolute',
      bottom: 0,
      width: '100%',
    },
    footerWhiteFont: {
      '&,&:hover,&:focus': {
        color: '#FFFFFF',
      },
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    separator: {
      marginLeft: spacing(),
      marginRight: spacing(),
    },
    contactUs: {
      position: 'relative',
      color: palette.common.white,
      textDecoration: 'none',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: parseInt(spacing()) / 8,
        bottom: -1,
        backgroundColor: palette.common.white,
        visibility: 'hidden',
        transform: 'scaleX(0)',
        transition: transitions.create('all'),
      },
      '&:hover:before': {
        visibility: 'visible',
        transform: 'scaleX(1)',
      },
    },
    list: {
      marginBottom: '0',
      padding: '0',
      marginTop: '0',
    },
    inlineBlock: {
      display: 'inline-block',
      padding: '0px',
      width: 'auto',
    },
    icon: {
      width: '18px',
      height: '18px',
      position: 'relative',
      top: '3px',
    },
  })

export default withStyles(styles)(Footer)
